import { render, staticRenderFns } from "./PeerView.vue?vue&type=template&id=c6ec2ffc&scoped=true&"
import script from "./PeerView.vue?vue&type=script&lang=js&"
export * from "./PeerView.vue?vue&type=script&lang=js&"
import style0 from "./PeerView.vue?vue&type=style&index=0&id=c6ec2ffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ec2ffc",
  null
  
)

export default component.exports